import React from "react";
import { isEmpty, orderBy } from "lodash";
import clsx from "clsx";
// components
import RMDRImage from "@/components/RMDRImage";
import ZebraShape02 from "@/components/shapes/ZebraShape02";
import SunShape02 from "@/components/shapes/SunShape02";
import RadiusShape01 from "@/components/shapes/RadiusShape01";
import CircleShape01 from "@/components/shapes/CircleShape01";
// import ContentRenderer from "@/components/ContentRenderer";
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
// import MNPG from "./MNPG";
// utilities
import { 
    outerNameDescriptionLanguageVersion, 
    pageNameDescriptionLanguageVersion 
} from "@/utilities/LanguageVersionSelectorShortcut";
import LanguageVersionSelector from "@/utilities/LanguageVersionSelector";
// enums
import EResourceType from "@/cms/enums/EResourceType";
import ELayoutType from "@/cms/enums/ELayoutType";
import EView from "@/cms/enums/EView";
import EContentType from "@/cms/enums/EContentType";
// types
import { TMainPageLayoutV2 } from "../type";
import TLanguageVersionList from "@/cms/types/TLanguageVersionList";
import TLanguageVersionDetail from "@/cms/types/TLanguageVersionDetail";
import TResource from "@/cms/types/TResource";


type TRender = {
    languageVersion: TLanguageVersionList|TLanguageVersionDetail;
    languageVersionPage?: TLanguageVersionDetail;
    
    resources: TResource[];
    resourceType: EResourceType;

    _layoutType?:ELayoutType;
}

const Render = ( props:TRender ) => {
    console.log("MNPG052.Render", props); 

    return (
        <section className={clsx("section", {"section-padding":props._layoutType}, {"section-padding-2":!props._layoutType})}>
            <ZebraShape02 className="float-bob-y" />
            <SunShape02 />
            <div className="container">
                <div className="about-activities-wrapper style-2">
                    <div className="row g-4">
                        <div
                            className="col-lg-6"
                            data-aos-duration="800"
                            data-aos="fade-up"
                            data-aos-delay="300"
                        >
                            <div className="activities-image-items">
                                <RMDRImage
                                    resources={props.resources}
                                    resourceType={props.resourceType}
                                    alt={props.languageVersion?.name}
                                    title={props.languageVersion?.name}
                                />
                                <RadiusShape01 />
                                <CircleShape01 />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="activities-content">
                                <div className="section-title">
                                    <h2
                                        data-aos-duration="800"
                                        data-aos="fade-up"
                                        data-aos-delay="300"
                                    >
                                        {props._layoutType === ELayoutType.MAIN_PAGE ? props.languageVersion.name : props.languageVersionPage?.name}
                                    </h2>
                                </div>
                                {
                                    props._layoutType === ELayoutType.MAIN_PAGE ? (
                                        <RMDRComponentSanitizer 
                                            languageVersion={props.languageVersion} 
                                            className="mt-3 mt-md-0"
                                            variant="div" 
                                            valueExpr="value"
                                            extraData={{"data-aos-duration": "800", "data-aos": "fade-up", "data-aos-delay": "500"}} 
                                            removeTag 
                                        />
                                    ) : (
                                        <RMDRComponentSanitizer 
                                            languageVersion={props.languageVersionPage} 
                                            className="mt-3 mt-md-0"
                                            variant="div" 
                                            valueExpr="value"
                                            extraData={{"data-aos-duration": "800", "data-aos": "fade-up", "data-aos-delay": "500"}} 
                                            removeTag 
                                        />
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

const RenderDetails = ( props:TMainPageLayoutV2 ) => {

    if ( !props.params?.["contentDetails"] || isEmpty(props.params?.["contentDetails"]) ) return null;

    const languageVersion = outerNameDescriptionLanguageVersion(props.params["contentDetails"].languageVersions);
    const languageVersionPage = LanguageVersionSelector<TLanguageVersionDetail|undefined>({
        languageVersions: props.params["contentDetails"].languageVersions,
        filters: [
            { view: EView.INNER, contentType: EContentType.PAGE }
        ],
        type: "find"
    });

    if ( !languageVersion || isEmpty(languageVersion) ) return null;

    return <Render 
        languageVersion={languageVersion}
        languageVersionPage={languageVersionPage}
        resources={props.params["contentDetails"].resources} 
        resourceType={EResourceType.INNER_IMAGE}
        _layoutType={props._layoutType}
    />

}

const RenderTemplate = ( props:TMainPageLayoutV2 ) => {

    if ( !props.template || isEmpty(props.template) ) return null;

    const languageVersions = pageNameDescriptionLanguageVersion(props.template.languageVersions);

    if ( !languageVersions || isEmpty(languageVersions) ) return null;

    return <Render 
        languageVersion={languageVersions} 
        resources={props.template.resources} 
        resourceType={EResourceType.OUTER_IMAGE}
        _layoutType={props._layoutType}
    />

}

const MNPG052 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG052.rendered", props); 

    if ( !props.template || isEmpty(props.template) ) return null;

    if ( props._layoutType === ELayoutType.MAIN_PAGE ) {
        return <RenderTemplate {...props} />
    }
    else {
        return <RenderDetails {...props} />
    }
}

const Component = React.memo(MNPG052, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    console.log("MNPG052.memo", { prevProps, nextProps });
    return true;
});

export default Component;
